module.exports = __webpack_public_path__ + "img/row-srp-preview-nissan.f4247220.png";